<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h1 class="headline">List of Instructors</h1>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="items.length == 0"
        select-all
        item-key="user_id"
        v-model="selected"
        class="elevation-3 mt-2"
      >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              primary
              hide-details
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.family_name }}</td>
          <td>{{ props.item.given_name }}</td>
          <td>{{ props.item.middle_name }}</td>
          <td>{{ props.item.ext_name }}</td>
          <td>{{ props.item.birthday }}</td>
          <td>{{ props.item.address }}</td>
          <td>{{ props.item.contact_number }}</td>
          <!-- <td><v-icon :color="props.item.verified ? 'green' : 'red'">{{ props.item.verified ? 'check' : 'clear' }}</v-icon></td> -->
        </template>
        <template slot="no-data">
          Nothing to display here :(
        </template>
      </v-data-table>
    </v-card>

    <!-- ACTION MODAL -->
    <v-dialog v-model="instructorDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ this.checkIfAdd ? 'Add' : 'Edit' }} an Instructor</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <!-- FORM -->
              <v-flex xs12 md6>
                <v-text-field
                  label="Username"
                  v-model="username"
                  required
                  v-if="checkIfAdd"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Password"
                  v-model="password"
                  type="password"
                  required
                  v-if="checkIfAdd"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Given Name"
                  v-model="givenName"
                  required
                  :error-messages="givenNameErrors"
                  @input="$v.givenName.$touch()"
                  @blur="$v.givenName.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Family Name"
                  v-model="familyName"
                  required
                  :error-messages="familyNameErrors"
                  @input="$v.familyName.$touch()"
                  @blur="$v.familyName.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Middle Name"
                  v-model="middleName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md1>
                <v-text-field
                  label="Ext."
                  v-model="extName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md5>
                <v-menu
                  ref="menu"
                  lazy
                  :close-on-content-click="false"
                  v-model="menu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Birthdate"
                    v-model="date"
                    prepend-icon="event"
                    readonly
                    required
                    :error-messages="dateErrors"
                    @input="$v.date.$touch()"
                    @blur="$v.date.$touch()"
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="date"
                    @change="save"  
                    :allowed-dates="allowedDates"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Address"
                  multi-line
                  rows="2"
                  v-model="address" 
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <p class="subheading">Gender:</p>
                <v-radio-group v-model="gender" row>
                  <v-radio label="Male" :value="true" ></v-radio>
                  <v-radio label="Female" :value="false"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Contact Number"
                  mask="###########"
                  v-model="contactNo"
                  :error-messages="contactNoErrors"
                  @input="$v.contactNo.$touch()"
                  @blur="$v.contactNo.$touch()"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <small>*indicates required field</small>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" flat @click.native="clearFormField">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="addInstructor" v-if="checkIfAdd">Save</v-btn>
          <v-btn color="blue darken-1" flat @click="editInstructor" v-else>Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE MODAL -->
    <v-layout row justify-center>
      <v-dialog v-model="deleteModal" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Warning!</v-card-title>
          <v-card-text>
            You are about to delete {{ this.selected.length }} instructor{{ this.selected.length > 0 ? 's' : '' }}. Are you sure?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" flat @click.native="deleteModal = false">Cancel</v-btn>
            <v-btn color="red darken-1" flat @click.native="deleteInstructors">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Floating button -->
    <v-speed-dial
      v-model="fab"
      :bottom="true"
      :right="true"
      :transition="'slide-y-reverse-transition'"
      :direction="'top'"
      fixed 
      :hover="true"
    >
      <v-btn
        slot="activator"
        fab
        color="red darken-1"
        dark 
        hover
        v-model="fab"
      >
        <v-icon>more_vert</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-tooltip left lazy>
        <v-btn
          slot="activator"
          small
          fab 
          dark 
          color="green"
          @click="setInstructorsAction(true)"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Add</span>
      </v-tooltip>
      <v-tooltip left lazy>
        <v-btn
          slot="activator"
          small
          fab
          dark
          color="amber"
          v-if="editSelected"
          @click="setInstructorsAction(false)"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <span>Edit</span>
      </v-tooltip>
      <v-tooltip left lazy>
        <v-btn
          slot="activator"
          small
          fab
          dark
          color="red"
          @click="deleteModal = true"
          v-if="deleteSelected"
        >
          <v-icon>delete</v-icon>
        </v-btn>
        <span>Delete</span>
      </v-tooltip>
    </v-speed-dial>
  </v-container>
</template>

<script>
import VueNotifications from 'vue-notifications'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    // username: {
    //   required
    // },
    // password: {
    //   required
    // },
    givenName: {
      required
    },
    familyName: {
      required
    },
    contactNo: {
      required
    }
  },
  data(){
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      selected: [],
      headers: [
        // { text: 'Select', value: 'select', align: 'center', sortable: false },
        { text: 'Family Name', value: 'family_name', align: 'left' },
        { text: 'Given Name', value: 'given_name', align: 'left' },
        { text: 'Middle Name', value: 'middle_name', align: 'left' },
        { text: 'Extension Name', value: 'ext_name', align: 'left' },
        { text: 'Birthdate', value: 'birthdate', align: 'left' },
        { text: 'Address', value: 'address', align: 'left' },
        { text: 'Contact No.', value: 'contact_number', align: 'left' },
        // { text: 'Verified', value: 'verified', align: 'left' }
      ],

      search: '',
      menu: false,
      date: null,
      instructorDialog: false,
      deleteModal: false,
      checkIfAdd: null,
      username: '',
      password: '',
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      address: '',
      contactNo: '',
      gender: true
    }
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    async addInstructor(){
      let { username, password, givenName, familyName, middleName, extName, address, contactNo, date, gender } = this
      this.$v.$touch()

      if(!this.$v.$error){
        this.$Progress.start()
        try{
          await axios.post('/api/accounts', {
            username: username,
            password: password,
            given_name: givenName,
            family_name: familyName,
            middle_name: middleName,
            ext_name: extName,
            birthday: date,
            address,
            contact_number: contactNo,
            user_role: 1,
            isMale: gender
          }, { 
            headers: { 
              'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`
            }})
          this.$store.dispatch('admin/FETCH_INSTRUCTORS')
          this.clearFormField()
          this.instructorDialog = false
          this.showSuccessMsg({ title: 'Success!', message: 'Instructor added successfully!' })
          this.$Progress.finish()
        }catch(e){
          console.log(e)
          this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.join(' ') })
          this.$Progress.fail()
        }
      }
    },
    async editInstructor(){
      let { username, password, givenName, familyName, middleName, extName, address, contactNo, date, gender } = this
      this.$v.$touch()

      if(!this.$v.$error){
        try{
          this.$Progress.start()
          await axios.post('/api/accounts/update', {
            user_id: this.selected[0].user_id,
            given_name: givenName,
            family_name: familyName,
            middle_name: middleName,
            ext_name: extName,
            birthday: date,
            address,
            contact_number: contactNo,
            isMale: gender
          }, { headers: { 
              'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`
            }})
          this.$store.dispatch('admin/FETCH_INSTRUCTORS')
          this.clearFormField()
          this.instructorDialog = false
          this.selected = []
          this.showSuccessMsg({ title: 'Success!', message: 'Instructor updated successfully!' })
          this.$Progress.finish()
        }catch(e){
          // this.clearFormField()
          // this.instructorDialog = false
          console.log(e)
          this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.join(' ') })
          this.$Progress.fail()
        }
      }
    },
    async deleteInstructors(){
      let instructors = this.selected.map(instructor => instructor.user_id)

      try{
        this.$Progress.start()
        await axios.delete('/api/accounts', {
          params: {
            ids: instructors
          },
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`
          }})
        this.$store.dispatch('admin/FETCH_INSTRUCTORS')
        this.deleteModal = false
        this.clearFormField()
        this.showSuccessMsg({ title: 'Success!', message: 'Instructor deleted successfully!' })
        this.selected = []
        this.$Progress.finish()
      }catch(e){
        console.log(e)
        this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.join(' ') })
        this.$Progress.fail()
      }
    },
    setInstructorsAction(action){
      this.checkIfAdd = action
      if(!action) {
        const { given_name, family_name, middle_name, ext_name, birthday, contact_number, isMale } = this.selected[0]
        this.givenName = given_name
        this.familyName = family_name
        this.middleName = middle_name
        this.extName = ext_name
        this.contactNo = contact_number
        this.date = birthday
        this.gender = isMale
      }
      this.instructorDialog = true
    },
    allowedDates(val){
      return new Date().toISOString().substr(0,10) >= val
    },
    save (date) {
      this.$refs.menu.save(date)
    },
    clearFormField(){
      this.instructorDialog = false
      this.username = '',
      this.password = '',
      this.givenName = '',
      this.familyName = '',
      this.middleName = '',
      this.extName = '',
      this.address = '',
      this.contactNo = ''
      this.gender = true
    }
  },
  created(){
    this.$store.dispatch('admin/FETCH_INSTRUCTORS')
    
  },
  computed: {
    items(){
      let items = this.$store.getters['admin/GET_INSTRUCTORS'].map(item => {
        return { ...item.profile, verified: item.verified, value: false }
      }).filter(item => {
        if(item.verified)
          return item
      })
      return items
    },
    dateErrors(){
      const errors = []
      if(!this.$v.date.$dirty) return errors
      !this.$v.date.required && errors.push('Birthdate is required')
      return errors
    },
    // userNameErrors(){
    //   const errors = []
    //   if(!this.$v.username.$dirty) return errors
    //   !this.$v.username.required && errors.push('Username is required')
    //   return errors
    // },
    // passwordErrors(){
    //   const errors = []
    //   if(!this.$v.password.$dirty) return errors
    //   !this.$v.password.required && errors.push('Password is required')
    //   return errors
    // },
    givenNameErrors(){
      const errors = []
      if(!this.$v.givenName.$dirty) return errors
      !this.$v.givenName.required && errors.push('Given name is required')
      return errors
    },
    familyNameErrors(){
      const errors = []
      if(!this.$v.familyName.$dirty) return errors
      !this.$v.familyName.required && errors.push('Family name is required')
      return errors
    },
    contactNoErrors(){
      const errors = []
      if(!this.$v.contactNo.$dirty) return errors
      !this.$v.contactNo.required && errors.push('Contact number is required')
      return errors
    },
    editSelected(){
      return this.selected.length == 1 ? true : false
    },
    deleteSelected(){
      return this.selected.length > 0 ? true : false
    }
  },
  notifications: {
    showSuccessMsg: { type: VueNotifications.types.success },
    showErrorMsg: { type: VueNotifications.types.error }
  }
}
</script>

<style>
.swal-title,
.swal-text,
.swal-button{
  font-family: 'Roboto',sans-serif;
}

.swal-button{
  background-color: #43a047;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instructor.vue